import script from "./TaxAddress.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaxAddress.vue?vue&type=script&setup=true&lang=ts"

import "./TaxAddress.vue?vue&type=style&index=0&id=28758f26&scoped=true&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28758f26"]])

export default __exports__